import { twMerge } from "tailwind-merge";
import { isAIRecommendationEnabled } from "../../../../integrations/posthog/featureFlags";
import { formatSummaryKey, SUMMARY_DISPLAY_ORDER } from "./CallFlow";
import { CertificationComments } from "./CertificationComments";

export function SummaryView({ assignmentId, assignmentSummary, canLeaveComments }: { assignmentId: string | undefined, assignmentSummary?: any, canLeaveComments?: boolean }) {
    const showAIRecommendation = isAIRecommendationEnabled();
    const summaries = assignmentSummary?.summaries || {};
    return (
        <div className="flex flex-col gap-2 h-[calc(100%-150px)] overflow-auto">
            <div className="border border-lightGray rounded-[10px] flex-1 min-h-[250px] h-[calc(100%-250px)]">
                <div
                    className={`flex flex-col gap-2 px-2 py-2.5 text-[#464646] font-semibold text-[clamp(10px,1.5vw,12px)] tracking-[0.3px] uppercase justify-center bg-[#F4F4F5] rounded-t-[10px] border-b border-lightGray`} >
                    Overall Performance
                </div>
                {showAIRecommendation && <div className="text-sm font-medium leading-[15px] px-3 my-2">
                    <span className="text-black">AI Recommendation:</span>
                    <span className="text-text2 text-black text-xs font-semibold leading-3 ml-1" >N/A</span>
                </div>}

                <div className={`relative bg-white rounded-[10px] overflow-y-auto h-[calc(100%-50px)]`}>

                    <div className={twMerge("bg-white rounded-[10px] py-3 overflow-y-auto")}>
                        <div className="pb-4 text-sm">

                            <>
                                <div className="border-b px-2.5 border-[#DFDFDF] pb-2.5">
                                    <div className="!text-[clamp(10px,1.5vw,12px)] font-semibold mb-1.5 uppercase text-headerPrimary">Summary</div>
                                    <div className="text-[clamp(10px,1.5vw,14px)] text-black">
                                        {assignmentSummary?.feedback || "No Summary Recorded"}
                                    </div>
                                </div>
                                {summaries && Object.keys(summaries).length > 0 && (
                                    <div className="mt-4">
                                        {(() => {
                                            const orderedKeys = [
                                                ...SUMMARY_DISPLAY_ORDER.filter((k) => k in summaries),
                                                ...Object.keys(summaries).filter((k) => !SUMMARY_DISPLAY_ORDER.includes(k)),
                                            ];
                                            return orderedKeys.map((key, index) => {
                                                const items = summaries[key];
                                                const list = Array.isArray(items) ? items : [];
                                                if (list.length === 0) return null;
                                                return (
                                                    <div key={key} className={twMerge("px-2.5  pb-2.5", index !== orderedKeys.length - 1 ? "border-b border-[#DFDFDF]" : "")}>
                                                        <div className="!text-[clamp(10px,1.5vw,12px)] font-semibold mb-1.5 uppercase text-headerPrimary my-3">{formatSummaryKey(key)}</div>
                                                        <ul className="list-disc space-y-2 ml-3.5">
                                                            {list.map((item, i) => (
                                                                <li key={i} className="text-sm">{item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                );
                                            });
                                        })()}
                                    </div>
                                )}
                            </>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex-1 min-h-[250px]">
                <CertificationComments className="h-full" assignmentId={assignmentId as string} canComment={canLeaveComments} />
            </div>
        </div>
    );
}